import React from "react";
import { Handle, Position, NodeResizer } from "reactflow";

const ImageNode = ({ data, selected }) => {
  return (
    <div
      className="image-node"
      style={{
        position: "relative",
        padding: "2px",
        minWidth: "100px",
        minHeight: "25px",
      }}
    >
      <NodeResizer isVisible={selected} minWidth={60} minHeight={40} />
      {data.img ? (
        <img src={data.img} alt={data.label} className="resizable-image" />
      ) : (
        <div>{data.label}</div> /* Fallback for nodes without images */
      )}
      <div className="image-label">{data.label}</div>
      <Handle type="source" position={Position.Right} />
      <Handle type="target" position={Position.Left} />
    </div>
  );
};

export default ImageNode;
